var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33411 13.0046C3.99356 13.0046 3.70203 12.8834 3.45951 12.6409C3.217 12.3984 3.09574 12.1068 3.09574 11.7663V3.71692H2.47656V2.47856H5.57247V1.85938H9.28756V2.47856H12.3835V3.71692H11.7643V11.7663C11.7643 12.1068 11.643 12.3984 11.4005 12.6409C11.158 12.8834 10.8665 13.0046 10.5259 13.0046H4.33411ZM10.5259 3.71692H4.33411V11.7663H10.5259V3.71692ZM5.57247 10.5279H6.81083V4.95528H5.57247V10.5279ZM8.04919 10.5279H9.28756V4.95528H8.04919V10.5279Z",
    fill: "#C50F3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete1);
export default __webpack_public_path__ + "static/media/delete-1.ccba3001c0857150b2478a2ce6c33246.svg";
export { ForwardRef as ReactComponent };